<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M13.3334 8V14.2667C13.3334 14.3192 13.3231 14.3712 13.303 14.4197C13.2829 14.4683 13.2534 14.5124 13.2163 14.5495C13.1791 14.5867 13.135 14.6161 13.0865 14.6362C13.038 14.6563 12.9859 14.6667 12.9334 14.6667H3.06675C3.01422 14.6667 2.9622 14.6563 2.91367 14.6362C2.86514 14.6161 2.82105 14.5867 2.78391 14.5495C2.74676 14.5124 2.7173 14.4683 2.6972 14.4197C2.67709 14.3712 2.66675 14.3192 2.66675 14.2667V8"
      stroke="#404A57"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.2667 4.66406H1.73337C1.62729 4.66406 1.52555 4.70621 1.45053 4.78122C1.37552 4.85623 1.33337 4.95798 1.33337 5.06406V7.5974C1.33337 7.70348 1.37552 7.80522 1.45053 7.88024C1.52555 7.95525 1.62729 7.9974 1.73337 7.9974H14.2667C14.3728 7.9974 14.4745 7.95525 14.5496 7.88024C14.6246 7.80522 14.6667 7.70348 14.6667 7.5974V5.06406C14.6667 4.95798 14.6246 4.85623 14.5496 4.78122C14.4745 4.70621 14.3728 4.66406 14.2667 4.66406V4.66406Z"
      stroke="#404A57"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 14.6641V4.66406"
      stroke="#404A57"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.00004 4.66536H5.00004C4.55801 4.66536 4.13409 4.48977 3.82153 4.17721C3.50897 3.86465 3.33337 3.44073 3.33337 2.9987C3.33337 2.55667 3.50897 2.13275 3.82153 1.82019C4.13409 1.50763 4.55801 1.33203 5.00004 1.33203C7.33337 1.33203 8.00004 4.66536 8.00004 4.66536Z"
      stroke="#404A57"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 4.66536H11C11.442 4.66536 11.866 4.48977 12.1785 4.17721C12.4911 3.86465 12.6667 3.44073 12.6667 2.9987C12.6667 2.55667 12.4911 2.13275 12.1785 1.82019C11.866 1.50763 11.442 1.33203 11 1.33203C8.66667 1.33203 8 4.66536 8 4.66536Z"
      stroke="#404A57"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
    name:"IconGift"
};
</script>

<style></style>
